import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import "react-data-table-component-extensions/dist/index.css";

import { loader_image } from "../_components/Imagepath";
import $ from "jquery";
import PropTypes from 'prop-types';

import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { base_url, Apitoken, Authtoken } from "../Global";
import "react-toastify/dist/ReactToastify.css";
import { MaterialReactTable } from 'material-react-table';
import Select from "react-select";

import Swal from 'sweetalert2';

const SupplyChainOrders = () => {
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);

  const [dataProduced, setDataProduced] = useState([]);
  const [dataConfirmed, setDataConfirmed] = useState([]);
  const [dataShipped, setDataShipped] = useState([]);

  const [dataDelivered, setDataDelivered] = useState([]);
  const [dataInproduction, setDataInproduction] = useState([]);
  const [dataPending, setDataPending] = useState([]);
  const [dataCancelled, setDataCancelled] = useState([]);
  const [permission, setPermission] = useState({});
  const topScrollRef = useRef(null);
  const tableContainerRef = useRef(null);
  const [customerList, setCustomerList] = useState([]);
  const statusOrder =
    [
      { id: 3, text: "CONFIRMED" },
      // { id: 2, text: "IN-PRODUCTION" },
      { id: 6, text: "PRODUCED" },
      { id: 4, text: "SHIPPED" }

    ];
  let season_id = localStorage.getItem("season_id");


  const statusOptions = [

    {
      "id": 4,
      "title": "SHIPPED",
      "type": 2,
      "color": "white",
      "bg_color": "green",
    },

    {
      "id": 6,
      "title": "PRODUCED",
      "type": 2,
      "color": "white",
      "bg_color": "green",
    },
    {
      "id": 7,
      "title": "DELIVERED",
      "type": 3,
      "color": "white",
      "bg_color": "brown",
    }

  ];
  console.log(statusOptions);

  const [formData, setFormData] = useState({
    customer: '',
    season_id: season_id,
    order_stats: '',
    start_eta_week: '',
    end_eta_week: '',

  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    console.log(formData);
    axios
      .post("/orders/filtered-list", formData, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      }).then((response) => {


        if (response.data.code === 200) {
          setData(response.data.data.orders);
        }
        else {
          //setBackendErrors(response.data.error);
        }
      })
      .catch((error) => {
        console.log(error);
        // actions.setSubmitting(false);
      });

  }
  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    console.log(Input_name);
    //delete backendErrors[Input_name];
  };

  useEffect(() => {
    setPermission(FindModuleById(433));
    console.log(permission);





    axios.post("/customers/listing", {}, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken } }).
      then((response) => {
        if (response.data.code === 200) {
          let incoterms = response.data.data.customers;
          let customerListing = incoterms.map((cust, index) => ({
            label: cust.company_name,
            value: cust.id,
            key: `types-${index}`,
          }));
          setCustomerList(customerListing);
        }

      })
      .catch((error) => {
        console.log(error);
      });

    axios.post("/orders/listing", formData, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
      .then((response) => {
        let all_orders = response.data.data.orders;
        let order_pending = [];
        let order_Inproduction = [];
        let order_Confirmed = [];
        let order_Shipped = [];
        let order_Cancelled = [];
        let order_Produced = [];
        let order_Delivered = [];
        all_orders.forEach((order) => {
          switch (order.order_status) {
            case 1:
              order_pending.push(order);
              break;
            case 2:
              order_Inproduction.push(order);
              break;
            case 3:
              order_Confirmed.push(order);
              break;
            case 4:
              order_Shipped.push(order);
              break;
            case 5:
              order_Cancelled.push(order);
              break;
            case 6:
              order_Produced.push(order);
              break;
            case 7:
              order_Delivered.push(order);
              break;

            default:
              break;
          }
        });

        setData(all_orders);
        setDataPending(order_pending);
        setDataInproduction(order_Inproduction);
        setDataConfirmed(order_Confirmed);
        setDataShipped(order_Shipped);
        setDataCancelled(order_Cancelled);
        setDataProduced(order_Produced);
        setDataDelivered(order_Delivered);
      }).catch((error) => { console.log(error); });


  }, []);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };


  const updateDate = async (id, type) => {
    try {
      const { value: date } = await Swal.fire({
        title: 'Update ETA Date',
        html: '<input type="date" id="datePicker" class="swal2-input">',
        showCancelButton: true,
        confirmButtonText: 'Update',
        cancelButtonText: 'Cancel',
        customClass: "swal-orders",
        preConfirm: () => document.getElementById('datePicker').value
      });

      if (!date) return; // Exit if no date is selected

      console.log('Selected date:', date);

      const response = await axios.get(`/production-orders/update-eta-date/${season_id + '-' + id}/${date}`, {
        headers: {
          Authorization: `Bearer ${Authtoken}`,
          Apitoken: Apitoken
        }
      });

      if (response.data.code === 200) {
        document.getElementById(`button-${type}-${id}`).textContent = response.data.data.date;

        await Swal.fire(
          'Success!',
          'Date Updated Successfully.',
          'success'
        );
      }
    } catch (error) {
      console.error('Error updating date:', error);
    }
  };


  const PONumberCell = ({ row }) => {
    return (
      <a href={`/supplychainorders-view/${row.original.id}`} className="">
        {row.original.po_number}
      </a>
    );
  };

  // ✅ Define PropTypes
  PONumberCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        po_number: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  };
  const OrderStatusCell = ({ row, statusOptions, changeOrderStatus }) => {
    return (
      <div className="btn-group custom-table-btn-group">
        <button
          type="button"
          className="btn btn-block dropdown-toggle me-1"
          id={`status-all-${row.original.id}`}
          style={{
            backgroundColor: row.original.status.bg_color,
            color: row.original.status.color,
          }}
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          {row.original.status ? row.original.status.title : ''}
        </button>
        <div className="dropdown-menu">
          {statusOptions &&
            statusOptions.map((shipp) => (
              <button
                key={shipp.id}
                className="dropdown-item btn btn-block"
                style={{ backgroundColor: shipp.bg_color, color: shipp.color }}
                onClick={() => changeOrderStatus(row.original.id, shipp.id, 'all')}
              >
                {shipp.title}
              </button>
            ))}
        </div>
      </div>
    );
  };

  // ✅ Define PropTypes
  OrderStatusCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        status: PropTypes.shape({
          title: PropTypes.string,
          bg_color: PropTypes.string,
          color: PropTypes.string,
        }),
      }).isRequired,
    }).isRequired,
    statusOptions: PropTypes.array.isRequired,
    changeOrderStatus: PropTypes.func.isRequired,
  };


  const OrderStatusDropdownCell = ({ row, permission, statusOptions, changeOrderStatus }) => {
    if (row.original.order_status === 6 || row.original.order_status === 7 || row.original.order_status === 4) {
      if (permission && permission.update == 1) {
        return (
          <div className="btn-group custom-table-btn-group">
            <button
              type="button"
              className="btn btn-block dropdown-toggle me-1"
              id={`status-all-${row.original.id}`}
              style={{ backgroundColor: row.original.status?.bg_color, color: row.original.status?.color }}
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              {row.original.status?.title || ''}
            </button>
            <div className="dropdown-menu">
              {statusOptions &&
                statusOptions.map((shipp) => (
                  <button
                    key={shipp.id}
                    className="dropdown-item btn btn-block"
                    style={{ backgroundColor: shipp.bg_color, color: shipp.color }}
                    onClick={() => changeOrderStatus(row.original.id, shipp.id, 'all')}
                  >
                    {shipp.title}
                  </button>
                ))}
            </div>
          </div>
        );
      }
    }

    return (
      <button
        type="button"
        className="btn btn-block me-1"
        id={`status-all-${row.original.id}`}
        style={{ backgroundColor: row.original.status?.bg_color, color: row.original.status?.color }}
      >
        {row.original.status?.title || ''}
      </button>
    );
  };

  // ✅ Fix PropTypes validation for `row`
  OrderStatusDropdownCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        order_status: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        status: PropTypes.shape({
          title: PropTypes.string,
          bg_color: PropTypes.string,
          color: PropTypes.string,
        }),
      }).isRequired,
    }).isRequired,
    permission: PropTypes.shape({
      update: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    statusOptions: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        title: PropTypes.string.isRequired,
        bg_color: PropTypes.string,
        color: PropTypes.string,
      })
    ).isRequired,
    changeOrderStatus: PropTypes.func.isRequired,
  };


  const ProductionDateCell = ({ row, permission, updateDate }) => {
    const { original } = row;

    return (
      <div>
        {permission?.update == 1 ? (
          <button
            className="btn btn-primary btn-block"
            id={`button-all-${original.id}`}
            onClick={() => updateDate(original.id, 'all')}
          >
            {original.planned_production_date ?? 'Update Date'}
          </button>
        ) : (
          <span>{original.planned_production_date ?? 'N/A'}</span>
        )}
      </div>
    );
  };


  // ✅ Define PropTypes
  ProductionDateCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        planned_production_date: PropTypes.string,
      }).isRequired,
    }).isRequired,
    permission: PropTypes.shape({
      update: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    updateDate: PropTypes.func.isRequired,
  };
  const ETADateCell = ({ row }) => (
    <div>
      <button
        className="btn btn-primary btn-block"
        id={`button-all-${row?.original?.id}`}
        onClick={() => updateDate(row?.original?.id, 'all')}
      >
        {row?.original?.eta_date ? row.original.eta_date : "Update Date"}
      </button>
    </div>
  );

  ETADateCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        eta_date: PropTypes.string,
      }),
    }),
  };

  const columns =
    [
      {
        header: 'PO Number',
        accessorFn: (row) => `${row.po_number}`,
        Cell: PONumberCell, // ✅ Use the separate component
      },
      {
        header: 'Customer',
        accessorFn: (row) => `${(row.customer) ? row.customer.company_name : ""} `,
      },
      {
        header: 'Order Progress',
        accessorKey: 'order_progress', // Give it a unique key for sorting
        accessorFn: (row) => {
          const totalSum = row.items.reduce((sum, item) => sum + item.pallet_number, 0);
          const production_outputs_total = row.production_outputs.length;
          return (((production_outputs_total / totalSum) * 100).toFixed(2) + '%');
        },
        sortDescFirst: true, // Set default sorting order to descending
      },
      {
        header: 'Order Status',
        accessorFn: (row) => row.status?.title || '',
        Cell: (props) => (
          <OrderStatusDropdownCell
            {...props}
            permission={permission}
            statusOptions={statusOptions}
            changeOrderStatus={changeOrderStatus}
          />
        ),
      },
      {
        header: 'Shipping Address',
        accessorFn: (row) => `${(row.ship_address) ? row.ship_address.name : ""} `,
      },
      {
        accessorKey: 'eta_week', //normal accessorKey
        header: 'Eta Week',
      },

      // {
      //   header: 'Production Date',
      //   accessorFn: (row) => row.planned_production_date || '',
      //   Cell: (props) => <ProductionDateCell {...props} permission={permission} updateDate={updateDate} />,
      // },


      {
        accessorKey: 'remarks', //normal accessorKey
        header: 'Note / Remark',
      },
      {
        header: 'ETA Date',
        accessorFn: (row) => `${row.eta_date}`,
        Cell: ETADateCell,
      },
      {
        header: 'Shipping method',
        accessorFn: (row) => `${(row.ship_method) ? row.ship_method.title : ""} `,
      },


      {
        header: 'Production Location',
        accessorFn: (row) => `${(row.order_location) ? row.order_location.title : ""} `,
      },

      {
        header: 'Total Amount',
        accessorFn: (row) => row.order_amount + `${(row.customer_currency) ? row.customer_currency.symbol : ""} `,
      },



      // {
      //   header: 'Production Location',
      //   accessorFn: (row) => `${(row.order_location)?row.order_location.title:""} `,
      // },
      // {
      //   header: 'Order Status',
      //   accessorFn: (row) => `${(row.status)?row.status.title:""} `,
      // },


      {
        header: 'Created By',
        accessorFn: (row) => `${(row.createdby) ? row.createdby.first_name + ' ' + row.createdby.last_name : ""} `,
      },
      {
        header: 'Updated By',
        accessorFn: (row) => `${(row.updatedby) ? row.updatedby.first_name + ' ' + row.updatedby.last_name : ""} `,
      },

    ];


  const columnsProduced =
    [
      {
        header: 'PO Number',
        accessorFn: (row) => `${row.po_number}`,
        Cell: PONumberCell, // ✅ Use the separate component
      },
      {
        header: 'Customer',
        accessorFn: (row) => `${(row.customer) ? row.customer.company_name : ""} `,
      },
      {
        header: 'Order Progress',
        accessorKey: 'order_progress', // Give it a unique key for sorting
        accessorFn: (row) => {
          const totalSum = row.items.reduce((sum, item) => sum + item.pallet_number, 0);
          const production_outputs_total = row.production_outputs.length;
          return (((production_outputs_total / totalSum) * 100).toFixed(2) + '%');
        },
        sortDescFirst: true, // Set default sorting order to descending
      },
      {
        header: 'Order Status',
        accessorFn: (row) => row.status?.title || '',
        Cell: (props) => (
          <OrderStatusDropdownCell
            {...props}
            permission={permission}
            statusOptions={statusOptions}
            changeOrderStatus={changeOrderStatus}
          />
        ),
      },
      {
        header: 'Shipping Address',
        accessorFn: (row) => `${(row.ship_address) ? row.ship_address.name : ""} `,
      },
      {
        accessorKey: 'eta_week', //normal accessorKey
        header: 'Eta Week',
      },

      // {
      //   header: 'Production Date',
      //   accessorFn: (row) => row.planned_production_date || '',
      //   Cell: (props) => <ProductionDateCell {...props} permission={permission} updateDate={updateDate} />,
      // },


      {
        accessorKey: 'remarks', //normal accessorKey
        header: 'Note / Remark',
      },
      {
        header: 'ETA Date',
        accessorFn: (row) => `${row.eta_date}`,
        Cell: ETADateCell,
      },
      {
        header: 'Shipping method',
        accessorFn: (row) => `${(row.ship_method) ? row.ship_method.title : ""} `,
      },


      {
        header: 'Production Location',
        accessorFn: (row) => `${(row.order_location) ? row.order_location.title : ""} `,
      },

      {
        header: 'Total Amount',
        accessorFn: (row) => row.order_amount + `${(row.customer_currency) ? row.customer_currency.symbol : ""} `,
      },




      {
        header: 'Created By',
        accessorFn: (row) => `${(row.createdby) ? row.createdby.first_name + ' ' + row.createdby.last_name : ""} `,
      },
      {
        header: 'Updated By',
        accessorFn: (row) => `${(row.updatedby) ? row.updatedby.first_name + ' ' + row.updatedby.last_name : ""} `,
      },

    ];


  const columnsConfirmed =
    [
      {
        header: 'PO Number',
        accessorFn: (row) => `${row.po_number}`,
        Cell: PONumberCell, // ✅ Use the separate component
      },
      {
        header: 'Customer',
        accessorFn: (row) => `${(row.customer) ? row.customer.company_name : ""} `,
      },
      {
        header: 'Order Progress',
        accessorKey: 'order_progress', // Give it a unique key for sorting
        accessorFn: (row) => {
          const totalSum = row.items.reduce((sum, item) => sum + item.pallet_number, 0);
          const production_outputs_total = row.production_outputs.length;
          return (((production_outputs_total / totalSum) * 100).toFixed(2) + '%');
        },

        sortDescFirst: true, // Set default sorting order to descending
      },
      {
        header: 'Order Status',
        accessorFn: (row) => `${row.status?.title || ''}`,
        Cell: OrderStatusDropdownCell, // ✅ Use a separate component
      },

      {
        header: 'Shipping Address',
        accessorFn: (row) => `${(row.ship_address) ? row.ship_address.name : ""} `,
      },
      {
        accessorKey: 'eta_week', //normal accessorKey
        header: 'Eta Week',
      },

      // {
      //   header: 'Production Date',
      //   accessorFn: (row) => row.planned_production_date || '',
      //   Cell: (props) => <ProductionDateCell {...props} permission={permission} updateDate={updateDate} />,
      // },


      {
        accessorKey: 'remarks', //normal accessorKey
        header: 'Note / Remark',
      },
      {
        header: 'ETA Date',
        accessorFn: (row) => `${row.eta_date}`,
        Cell: ETADateCell,
      },
      {
        header: 'Shipping method',
        accessorFn: (row) => `${(row.ship_method) ? row.ship_method.title : ""} `,
      },


      {
        header: 'Production Location',
        accessorFn: (row) => `${(row.order_location) ? row.order_location.title : ""} `,
      },

      {
        header: 'Total Amount',
        accessorFn: (row) => row.order_amount + `${(row.customer_currency) ? row.customer_currency.symbol : ""} `,
      },


      {
        header: 'Created By',
        accessorFn: (row) => `${(row.createdby) ? row.createdby.first_name + ' ' + row.createdby.last_name : ""} `,
      },
      {
        header: 'Updated By',
        accessorFn: (row) => `${(row.updatedby) ? row.updatedby.first_name + ' ' + row.updatedby.last_name : ""} `,
      },


    ];


  const columnsShipped =
    [
      {
        header: 'PO Number',
        accessorFn: (row) => `${row.po_number}`,
        Cell: PONumberCell, // ✅ Use the separate component
      },
      {
        header: 'Customer',
        accessorFn: (row) => `${(row.customer) ? row.customer.company_name : ""} `,
      },
      {
        header: 'Order Progress',
        accessorKey: 'order_progress', // Give it a unique key for sorting
        accessorFn: (row) => {
          const totalSum = row.items.reduce((sum, item) => sum + item.pallet_number, 0);
          const production_outputs_total = row.production_outputs.length;
          return (((production_outputs_total / totalSum) * 100).toFixed(2) + '%');
        },

        sortDescFirst: true, // Set default sorting order to descending
      },
      {
        header: 'Order Status',
        accessorFn: (row) => `${row.status?.title || ''}`,
        Cell: OrderStatusDropdownCell, // ✅ Use a separate component
      },
      {
        header: 'Shipping Address',
        accessorFn: (row) => `${(row.ship_address) ? row.ship_address.name : ""} `,
      },
      {
        accessorKey: 'eta_week', //normal accessorKey
        header: 'Eta Week',
      },

      // {
      //   header: 'Production Date',
      //   accessorFn: (row) => row.planned_production_date || '',
      //   Cell: (props) => <ProductionDateCell {...props} permission={permission} updateDate={updateDate} />,
      // },


      {
        accessorKey: 'remarks', //normal accessorKey
        header: 'Note / Remark',
      },
      {
        header: 'ETA Date',
        accessorFn: (row) => `${row.eta_date}`,
        Cell: ETADateCell,
      },
      {
        header: 'Shipping method',
        accessorFn: (row) => `${(row.ship_method) ? row.ship_method.title : ""} `,
      },


      {
        header: 'Production Location',
        accessorFn: (row) => `${(row.order_location) ? row.order_location.title : ""} `,
      },

      {
        header: 'Total Amount',
        accessorFn: (row) => row.order_amount + `${(row.customer_currency) ? row.customer_currency.symbol : ""} `,
      },

      {
        header: 'Created By',
        accessorFn: (row) => `${(row.createdby) ? row.createdby.first_name + ' ' + row.createdby.last_name : ""} `,
      },
      {
        header: 'Updated By',
        accessorFn: (row) => `${(row.updatedby) ? row.updatedby.first_name + ' ' + row.updatedby.last_name : ""} `,
      },


    ];

  const columnsInproduction =
    [
      {
        header: 'PO Number',
        accessorFn: (row) => `${row.po_number}`,
        Cell: PONumberCell, // ✅ Use the separate component
      },
      {
        header: 'Customer',
        accessorFn: (row) => `${(row.customer) ? row.customer.company_name : ""} `,
      },
      {
        header: 'Order Progress',
        accessorKey: 'order_progress', // Give it a unique key for sorting
        accessorFn: (row) => {
          const totalSum = row.items.reduce((sum, item) => sum + item.pallet_number, 0);
          const production_outputs_total = row.production_outputs.length;
          return (((production_outputs_total / totalSum) * 100).toFixed(2) + '%');
        },

        sortDescFirst: true, // Set default sorting order to descending
      },
      {
        header: 'Order Status',
        accessorFn: (row) => `${row.status?.title || ''}`,
        Cell: OrderStatusDropdownCell, // ✅ Use a separate component
      },
      {
        header: 'Shipping Address',
        accessorFn: (row) => `${(row.ship_address) ? row.ship_address.name : ""} `,
      },
      {
        accessorKey: 'eta_week', //normal accessorKey
        header: 'Eta Week',
      },

      // {
      //   header: 'Production Date',
      //   accessorFn: (row) => row.planned_production_date || '',
      //   Cell: (props) => <ProductionDateCell {...props} permission={permission} updateDate={updateDate} />,
      // },


      {
        accessorKey: 'remarks', //normal accessorKey
        header: 'Note / Remark',
      },
      {
        header: 'ETA Date',
        accessorFn: (row) => `${row.eta_date}`,
        Cell: ETADateCell,
      },
      {
        header: 'Shipping method',
        accessorFn: (row) => `${(row.ship_method) ? row.ship_method.title : ""} `,
      },


      {
        header: 'Production Location',
        accessorFn: (row) => `${(row.order_location) ? row.order_location.title : ""} `,
      },

      {
        header: 'Total Amount',
        accessorFn: (row) => row.order_amount + `${(row.customer_currency) ? row.customer_currency.symbol : ""} `,
      },


      {
        header: 'Created By',
        accessorFn: (row) => `${(row.createdby) ? row.createdby.first_name + ' ' + row.createdby.last_name : ""} `,
      },
      {
        header: 'Updated By',
        accessorFn: (row) => `${(row.updatedby) ? row.updatedby.first_name + ' ' + row.updatedby.last_name : ""} `,
      },

    ];

  const columnsDelivered =
    [
      {
        header: 'PO Number',
        accessorFn: (row) => `${row.po_number}`,
        Cell: PONumberCell, // ✅ Use the separate component
      },
      {
        header: 'Customer',
        accessorFn: (row) => `${(row.customer) ? row.customer.company_name : ""} `,
      },
      {
        header: 'Order Progress',
        accessorKey: 'order_progress', // Give it a unique key for sorting
        accessorFn: (row) => {
          const totalSum = row.items.reduce((sum, item) => sum + item.pallet_number, 0);
          const production_outputs_total = row.production_outputs.length;
          return (((production_outputs_total / totalSum) * 100).toFixed(2) + '%');
        },
        sortDescFirst: true, // Set default sorting order to descending
      },
      {
        header: 'Order Status',
        accessorFn: (row) => row.status?.title || '',
        Cell: (props) => (
          <OrderStatusDropdownCell
            {...props}
            permission={permission}
            statusOptions={statusOptions}
            changeOrderStatus={changeOrderStatus}
          />
        ),
      },

      {
        header: 'Shipping Address',
        accessorFn: (row) => `${(row.ship_address) ? row.ship_address.name : ""} `,
      },
      {
        accessorKey: 'eta_week', //normal accessorKey
        header: 'Eta Week',
      },

      // {
      //   header: 'Production Date',
      //   accessorFn: (row) => row.planned_production_date || '',
      //   Cell: (props) => <ProductionDateCell {...props} permission={permission} updateDate={updateDate} />,
      // },


      {
        accessorKey: 'remarks', //normal accessorKey
        header: 'Note / Remark',
      },
      {
        header: 'ETA Date',
        accessorFn: (row) => `${row.eta_date}`,
        Cell: ETADateCell,
      },
      {
        header: 'Shipping method',
        accessorFn: (row) => `${(row.ship_method) ? row.ship_method.title : ""} `,
      },


      {
        header: 'Production Location',
        accessorFn: (row) => `${(row.order_location) ? row.order_location.title : ""} `,
      },

      {
        header: 'Total Amount',
        accessorFn: (row) => row.order_amount + `${(row.customer_currency) ? row.customer_currency.symbol : ""} `,
      },


      {
        header: 'Created By',
        accessorFn: (row) => `${(row.createdby) ? row.createdby.first_name + ' ' + row.createdby.last_name : ""} `,
      },
      {
        header: 'Updated By',
        accessorFn: (row) => `${(row.updatedby) ? row.updatedby.first_name + ' ' + row.updatedby.last_name : ""} `,
      },

    ];



  const changeOrderStatus = (user_id, status, type) => {

    Swal.fire({
      title: 'Do you want change Status?',
      //text: 'This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: 'green',
      cancelButtonColor: '#d33',
      confirmButtonText: 'CONFIRM',
      customClass: "swal-orders"
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/production-orders/change-status/${season_id + '-' + user_id}/${status}`, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
          .then((response) => {
            console.log(response);
            if (response.data.code === 200) {
              $("#status-" + type + "-" + user_id).text(response.data.data.order_status.title);
              $("#status-" + type + "-" + user_id).css('background-color', response.data.data.order_status.bg_color);
              $("#status-" + type + "-" + user_id).css('color', response.data.data.order_status.color);
              Swal.fire(
                'Success!',
                'Order Status has been changed Successfully.',
                'success'
              );
              axios.post("/production-orders/listing", formData, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
                .then((response) => {
                  let all_orders = response.data.data.orders;
                  let order_pending = [];
                  let order_Inproduction = [];
                  let order_Confirmed = [];
                  let order_Shipped = [];
                  let order_Cancelled = [];
                  let order_Produced = [];
                  let order_Delivered = [];
                  all_orders.forEach((order) => {
                    switch (order.order_status) {
                      case 1:
                        order_pending.push(order);
                        break;
                      case 2:
                        order_Inproduction.push(order);
                        break;
                      case 3:
                        order_Confirmed.push(order);
                        break;
                      case 4:
                        order_Shipped.push(order);
                        break;
                      case 5:
                        order_Cancelled.push(order);
                        break;
                      case 6:
                        order_Produced.push(order);
                        break;
                      case 7:
                        order_Delivered.push(order);
                        break;

                      default:
                        break;
                    }
                  });

                  setData(all_orders);
                  setDataPending(order_pending);
                  setDataInproduction(order_Inproduction);
                  setDataConfirmed(order_Confirmed);
                  setDataShipped(order_Shipped);
                  setDataCancelled(order_Cancelled);
                  setDataProduced(order_Produced);
                  setDataDelivered(order_Delivered);
                }).catch((error) => { console.log(error); });

            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  }

  function objectToQueryString(obj) {
    return Object.keys(obj)
      .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
      .join('&');
  }
  const downloadExcel = (e) => {
    console.log(e)

    const queryString = objectToQueryString(formData);

    window.open(`${base_url}/orders/listing-excel-open?${queryString}`, '_blank');

    $("#loader-image2").addClass('loader-hide2');
    $("#loader-image2").removeClass('loader-show2');


  }
  // Sync scrollbars for main table
  useEffect(() => {
    const syncScrollbars = () => {
      const tableContainer = document.querySelector('.production-output-listing .MuiTableContainer-root');
      const topScroll = topScrollRef.current;
      const topScrollContent = topScroll?.querySelector('.top-scroll-content');

      if (tableContainer && topScroll && topScrollContent) {
        topScrollContent.style.width = `${tableContainer.scrollWidth}px`;

        const handleTopScroll = () => {
          tableContainer.scrollLeft = topScroll.scrollLeft;
        };

        const handleTableScroll = () => {
          topScroll.scrollLeft = tableContainer.scrollLeft;
        };

        topScroll.addEventListener('scroll', handleTopScroll);
        tableContainer.addEventListener('scroll', handleTableScroll);

        return () => {
          topScroll.removeEventListener('scroll', handleTopScroll);
          tableContainer.removeEventListener('scroll', handleTableScroll);
        };
      }
    };

    const timer = setTimeout(syncScrollbars, 100);
    return () => clearTimeout(timer);
  }, [data]);
  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar />
      {/* <ToastContainer /> */}

      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Supply Chain Orders</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item active">Supply Chain Orders</li>
                </ul>
              </div>
              <div className="col-auto">

                {/* &nbsp;&nbsp;
                  <a
                    className="btn btn-primary filter-btn"
                    href="/production-orders#"
                    id="filter_search"
                  >
                    <i className="fas fa-filter"></i>
                  </a> */}
                &nbsp;&nbsp;
                <button
                  className="btn btn-primary"
                  onClick={() => downloadExcel()}
                >
                  <i className="fa fa-file-excel-o"></i>  <i className="fa fa-download"></i><img id="loader-image2" className="loader-image2 loader-hide2" src={loader_image} />
                </button>
              </div>
            </div>
          </div>

          <div id="filter_inputs" className="card filter-card2">
            <div className="card-body pb-0">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-3" style={{ display: 'none' }}>
                    <div className="form-group">
                      <label>Select Customer:</label>

                      <Select
                        className="w-100"
                        data={customerList}
                        value={formData.customer}
                        name="customer"
                        onChange={(e) => {
                          handleChange(e);
                          customHandleInput(e);
                        }}

                        options={{
                          placeholder: "Select Customer",
                        }}
                      />
                    </div>
                  </div>

                  <div className="col-md-2" style={{ display: 'none' }}>
                    <div className="form-group">
                      <label>Select Order Status:</label>
                      <Select
                        className="w-100"
                        data={statusOrder}
                        value={formData.order_stats}
                        name="order_stats"
                        onChange={(e) => {
                          handleChange(e);
                          customHandleInput(e);
                        }}

                        options={{
                          placeholder: "Select Order Status",
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <label>Start ETA Week:</label>
                      <input type="text" name="start_eta_week" placeholder="Enter Start ETA Week" className="form-control" value={formData.start_eta_week} onChange={(e) => {
                        handleChange(e);
                        customHandleInput(e);
                      }} />
                    </div>
                  </div>

                  <div className="col-md-2">
                    <div className="form-group">
                      <label>End ETA Week:</label>
                      <input type="text" name="end_eta_week" placeholder="Enter End ETA Week" className="form-control" value={formData.end_eta_week} onChange={(e) => {
                        handleChange(e);
                        customHandleInput(e);
                      }} />
                    </div>
                  </div>

                  <div className="col-md-2">
                    <div className="pt-4 mt-2">
                      <button type="submit" className="btn btn-primary">
                        Filter
                      </button>
                      &nbsp;&nbsp;
                      <a href="/supplychainorders" className="btn btn-primary me-1"><i className="fa fa-times"></i></a>
                    </div>
                  </div>
                </div>
              </form>

            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              {permission && permission.list == 1 && (

                <section className="comp-section">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="card bg-white">

                        <div className="card-body">
                          <ul className="nav nav-tabs nav-tabs-bottom">

                            <li className="nav-item">
                              <a className="nav-link active" href="#all-orders" data-bs-toggle="tab">All Orders ({data.length})</a>
                            </li>

                            <li className="nav-item">
                              <a className="nav-link" href="#list-pending" data-bs-toggle="tab"> Pending Orders ({dataPending.length})</a>
                            </li>
                            <li className="nav-item">
                              <a className="nav-link" href="#list-cancelled" data-bs-toggle="tab"> Cancelled Orders ({dataCancelled.length})</a>
                            </li>
                            <li className="nav-item">
                              <a className="nav-link" href="#list-Confirmed" data-bs-toggle="tab"> Confirmed Orders ({dataConfirmed.length})</a>
                            </li>

                            <li className="nav-item">
                              <a className="nav-link" href="#list-Shipped" data-bs-toggle="tab"> Shipped Orders ({dataShipped.length})</a>
                            </li>

                            <li className="nav-item">
                              <a className="nav-link" href="#list-Produced" data-bs-toggle="tab"> Produced Orders ({dataProduced.length})</a>
                            </li>
                            <li className="nav-item">
                              <a className="nav-link" href="#list-In-production" data-bs-toggle="tab"> In-Production Orders ({dataInproduction.length})</a>
                            </li>
                            <li className="nav-item">
                              <a className="nav-link" href="#list-delivered" data-bs-toggle="tab"> Delivered Orders ({dataDelivered.length})</a>
                            </li>
                          </ul>
                          <div className="tab-content">
                            <div className="tab-pane show active" id="all-orders">
                              <div className="row" id="listing-followup-groupby" >
                                <div className="col-sm-12" >
                                  <div className="card card-table">
                                    <div className="card-body"> <div
                                      ref={topScrollRef}
                                      className="top-scrollbar"
                                      style={{
                                        overflowX: 'auto',
                                        overflowY: 'hidden',
                                        marginBottom: '10px',
                                        height: '80px'
                                      }}
                                    >
                                      <div className="top-scroll-content" style={{ height: '1px' }}></div>
                                    </div>
                                      <div className="table-responsive production-output-listing" ref={tableContainerRef}>
                                        <MaterialReactTable columns={columns} data={data}
                                          enableColumnOrdering
                                          enablePinning

                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>


                            <div className="tab-pane " id="list-pending">
                              <div className="row" id="listing-followup">
                                <div className="col-sm-12">
                                  <div className="card card-table">
                                    <div className="card-body">
                                      <div className="table-responsive">

                                        <MaterialReactTable columns={columnsConfirmed} data={dataPending}
                                          enableColumnOrdering
                                          enablePinning

                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="tab-pane " id="list-Confirmed">
                              <div className="row" id="listing-followup">
                                <div className="col-sm-12">
                                  <div className="card card-table">
                                    <div className="card-body">
                                      <div className="table-responsive">

                                        <MaterialReactTable columns={columnsConfirmed} data={dataConfirmed}
                                          enableColumnOrdering
                                          enablePinning

                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="tab-pane " id="list-cancelled">
                              <div className="row" id="listing-followup">
                                <div className="col-sm-12">
                                  <div className="card card-table">
                                    <div className="card-body">
                                      <div className="table-responsive">

                                        <MaterialReactTable columns={columnsConfirmed} data={dataCancelled}
                                          enableColumnOrdering
                                          enablePinning

                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="tab-pane " id="list-Shipped">
                              <div className="row" id="listing-followup">
                                <div className="col-sm-12">
                                  <div className="card card-table">
                                    <div className="card-body">
                                      <div className="table-responsive">

                                        <MaterialReactTable columns={columnsShipped} data={dataShipped}
                                          enableColumnOrdering
                                          enablePinning

                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>


                            <div className="tab-pane " id="list-Produced">
                              <div className="row" id="listing-followup">
                                <div className="col-sm-12">
                                  <div className="card card-table">
                                    <div className="card-body">
                                      <div className="table-responsive">

                                        <MaterialReactTable columns={columnsProduced} data={dataProduced}
                                          enableColumnOrdering
                                          enablePinning

                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="tab-pane " id="list-In-production">
                              <div className="row" id="listing-followup">
                                <div className="col-sm-12">
                                  <div className="card card-table">
                                    <div className="card-body">
                                      <div className="table-responsive">

                                        <MaterialReactTable columns={columnsInproduction} data={dataInproduction}
                                          enableColumnOrdering
                                          enablePinning

                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="tab-pane " id="list-delivered">
                              <div className="row" id="listing-followup">
                                <div className="col-sm-12">
                                  <div className="card card-table">
                                    <div className="card-body">
                                      <div className="table-responsive">

                                        <MaterialReactTable columns={columnsDelivered} data={dataDelivered}
                                          enableColumnOrdering
                                          enablePinning

                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              )}


            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SupplyChainOrders;
